module.exports = __webpack_public_path__ + "static/img/app-tip-text.9097894b.png";